import { AxiosInterceptor } from "api/core/consts";

export const companyPageCode = {
  getCompanyPageCodes: () => AxiosInterceptor.get('/companyPageCode?size=100'),
  searchCompanyPageCode: (body) => AxiosInterceptor.post('companyPageCode/search?size=100', body),
  createCompanyPageCode: (body) => AxiosInterceptor.post('companyPageCode', body),
  updateCompanyPageCode: (companyPageCodeId, body) => AxiosInterceptor.put('companyPageCode/' + companyPageCodeId, body),
  deleteCompanyPageCode: (companyPageCodeId) => AxiosInterceptor.delete('companyPageCode/' + companyPageCodeId),
};
